import template from './file-card.html';

export default {
  template,
  bindings: {
     name: '=',
     thumbnail: '=',
     source: '=',
     date: '=' ,
     isRemovable: '=',
     locale: '=',
     deleteAction: '&',
     downloadAction: '&',
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/file-card/file-card-component.js